import React, { useState, useRef } from "react";
import { Image } from "react-bootstrap";
import { Stack, Panel, Form, Text, Divider, VStack, Button } from "rsuite";
import * as htmlToImage from "html-to-image";
import { google, outlook, office365, yahoo, ics } from "calendar-link";
import { FaCalendar } from "react-icons/fa";

export const CitaConfirmada = () => {
  const [idNegocio] = useState(JSON.parse(sessionStorage.getItem("dataCita")).id);

  const [uuidCita] = useState(
    JSON.parse(sessionStorage.getItem("uuidCita")).uuidCita
  );
  const [negocio] = useState(
    JSON.parse(sessionStorage.getItem("dataCita")).negocio
  );
  const domicilio = useState(
    JSON.parse(sessionStorage.getItem("dataCita")).domicilio
  );
  const edoMun = useState(JSON.parse(sessionStorage.getItem("dataCita")).edoMun);

  const [fecha] = useState(JSON.parse(sessionStorage.getItem("dataCita")).fecha);
  const [hora] = useState(JSON.parse(sessionStorage.getItem("dataCita")).hora);
  const [telNegocio] = useState(
    JSON.parse(sessionStorage.getItem("dataCita")).telNegocio
  );

  const [nombre] = useState(
    JSON.parse(sessionStorage.getItem("dataCita")).nombre
  );
  const titulo = `Cita con ${
    JSON.parse(sessionStorage.getItem("dataCita")).nomConsultorio
  }`;
  const location = JSON.parse(sessionStorage.getItem("dataCita")).domicilio;
  const details = `Cita agendada en: ${
    JSON.parse(sessionStorage.getItem("dataCita")).domicilio
  }`;
  const _data = JSON.parse(
    sessionStorage.getItem("uuidCita")
  ).uuidCita.toString();
  const _fec = _data.split("-");

  const event = {
    title: `${titulo} ${negocio}`,
    description: location,
    location: location,
    start: `${fecha} ${hora}`,
    duration: [1, "hour"],
  };

  const googleUrl = google(event);
  const outlookUrl = outlook(event);

  // const googleUrl = google({
  //   title: `${titulo} ${negocio}`,
  //   description: location,
  //   location: location,
  //   start: `${fecha} ${hora}`,
  //   duration: [1, "hour"],
  // });

  const createFileName = (extension = "", ...names) => {
    if (!extension) {
      return "";
    }
    return `${names.join("")}.${extension}`;
  };

  const downloadFile = (image, { name = "Cita", extension = "jpg" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const screenshotArea = useRef(null);

  const handleDownload = async () => {
    if (!screenshotArea.current) return;
    await htmlToImage.toJpeg(screenshotArea.current).then(downloadFile);
    alert("Se ha descargado un documento: Cita.jpg");
  };

  const goTo = (page, windowOut) => {
    if (windowOut === 0) {
      window.location = `/#/${negocio}`;
    } else {
      window.open(page, "_blank");
    }
  };

  return (
    <>
      <div ref={screenshotArea} style={{ backgroundColor: "white" }}>
        <center>
          <Image
            src="Images/CitaConfirmada.png"
            style={{ height: 60, margin: 10 }}
          />
        </center>
        <Stack
          alignItems="center"
          justifyContent="center"
          style={{ height: "100%" }}
        >
          <Panel style={{ marginTop: 0 }}>
            <Form fluid style={{ fontSize: "18px" }}>
              <Form.Group>
                <Form.Label>
                  <Text weight="bold" size="lg">
                    Identificador de Cita
                  </Text>
                </Form.Label>
                <Form.Label>{uuidCita}</Form.Label>
              </Form.Group>

              <Form.Group>
                <Form.Label>
                  <Text weight="bold" size="lg">
                    Fecha y Hora
                  </Text>
                </Form.Label>
                <Form.Label>
                  {fecha} a las {hora.substring(0, 5)} Hrs.
                </Form.Label>
              </Form.Group>

              <Form.Group>
                <Form.Label>
                  <Text weight="bold" size="lg">
                    Nombre
                  </Text>
                </Form.Label>
                <Form.Label>{nombre}</Form.Label>
              </Form.Group>

              <Divider>
                <Text weight="bold" size="lg">
                  Domicilio
                </Text>
              </Divider>
              <Text size="md" weight="semibold">
                {domicilio}
                <br></br>
                {edoMun}
              </Text>

              <Divider></Divider>

              <Form.Group>
                <center>
                  <Image
                    src={`Images/Negocios/${idNegocio}.png?v=${new Date().getTime()}`}
                    style={{ width: 250 }}
                  />
                </center>
                <b></b>
                <center>
                  <Text size="sm" color="red">
                    Cancelar enviar WhatsApp al: {telNegocio}
                  </Text>
                </center>
              </Form.Group>

              <center>
                <VStack style={{ alignContent: 'center', alignSelf: 'center' }}>
                  <a
                    href={googleUrl}
                    className="btn btn-secondary"
                    style={{ textDecoration: "none", fontSize: "14px" }}
                    target="_blank"
                  >
                    <FaCalendar></FaCalendar> &nbsp; Agregar a calendario
                  </a>

                  <Button
                    block
                    appearance="primary"
                    onClick={() => goTo("", 0)}
                  >
                    Nueva cita
                  </Button>
                </VStack>
              </center>
            </Form>
          </Panel>
        </Stack>
      </div>
    </>
  );
};
